const Download = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.16675 11.5V13.2C2.16675 13.918 2.74878 14.5 3.46675 14.5H8.66675H13.8667C14.5847 14.5 15.1667 13.918 15.1667 13.2V11.5"
      stroke="#1890FF"
      strokeWidth="1.33"
      strokeLinecap="round"
    />
    <path
      d="M8.40016 11.2C8.43121 11.2414 8.47147 11.275 8.51776 11.2981C8.56404 11.3213 8.61508 11.3333 8.66683 11.3333C8.71858 11.3333 8.76962 11.3213 8.8159 11.2981C8.86219 11.275 8.90245 11.2414 8.9335 11.2L11.9335 7.2C11.9706 7.15048 11.9933 7.09159 11.9988 7.02994C12.0044 6.96828 11.9927 6.9063 11.965 6.85093C11.9373 6.79556 11.8947 6.74899 11.8421 6.71645C11.7894 6.68391 11.7287 6.66667 11.6668 6.66667H9.3335V1.66667C9.3335 1.48986 9.26326 1.32029 9.13823 1.19526C9.01321 1.07024 8.84364 1 8.66683 1C8.49002 1 8.32045 1.07024 8.19543 1.19526C8.0704 1.32029 8.00016 1.48986 8.00016 1.66667V6.66667H5.66683C5.60493 6.66667 5.54424 6.68391 5.49159 6.71645C5.43893 6.74899 5.39637 6.79556 5.36869 6.85093C5.341 6.9063 5.32928 6.96828 5.33484 7.02994C5.3404 7.09159 5.36302 7.15048 5.40016 7.2L8.40016 11.2Z"
      fill="#1890FF"
    />
  </svg>
)

export default Download
